import { render } from "./three-models.vue?vue&type=template&id=b30679c6"
import script from "./three-models.vue?vue&type=script&lang=js"
export * from "./three-models.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__